const PermissionActionTypes = {};

PermissionActionTypes.FETCH_PERMISSIONS = 'FETCH_PERMISSIONS';
PermissionActionTypes.FETCH_PERMISSION_BY_ROLE = 'FETCH_PERMISSION_BY_ROLE';
PermissionActionTypes.ADD_ROLE_PERMISSION = 'ADD_ROLE_PERMISSION';
PermissionActionTypes.FETCH_PERMISSION_BY_USER = 'FETCH_PERMISSION_BY_USER';
PermissionActionTypes.ADD_USER_PERMISSION = 'ADD_USER_PERMISSION';

export default PermissionActionTypes;
